import { rtkApi } from 'app/store/AppStore.rtk'
import { DEFAULT_SEASON } from 'features/Env'
import { StandingsRequest, StandingsResponse } from 'types'

export const standingsApi = rtkApi
  .enhanceEndpoints({
    addTagTypes: ['standings'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getStandings: build.query<StandingsResponse, StandingsRequest>({
        query: ({
          stateId,
          districtId,
          sportId,
          isOverall,
          showEmptyResults,
        }: StandingsRequest) => {
          return {
            url: `/schoolsResults`,
            params: {
              stateId,
              districtId,
              sportId,
              year: DEFAULT_SEASON,
              isOverallRecordMode: isOverall,
              showEmptyResults,
            },
          }
        },
        providesTags: ['standings'],
      }),
    }),
  })

export const { useGetStandingsQuery } = standingsApi
